'use client';

import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { useCallback, useEffect, useRef, useState } from 'react';
import TESTIMONIALS from './testimonials.data.json' with { type: 'json' };

import './IntakeTestimonialsSectionMobile.scss';

export const IntakeTestimonialsSectionMobile = () => {
  const [current, setCurrent] = useState(0);

  const ref = useRef<HTMLDivElement | null>(null);

  const numberOfElements = TESTIMONIALS.length;

  const handleScrollEnd = useCallback(
    (currentElement: HTMLDivElement) => {
      const { scrollLeft: scrollValue, scrollWidth } = currentElement;

      const elementWidth = scrollWidth / numberOfElements;

      const treshold = TESTIMONIALS.map((_, index) => [
        index * elementWidth,
        (index + 1) * elementWidth,
      ]);

      const newIndex = treshold.findIndex(
        ([left, right]) => scrollValue >= left && scrollValue < right
      );

      setCurrent(newIndex);
    },
    [numberOfElements]
  );

  useEffect(() => {
    const { current: currentElement } = ref;

    if (!currentElement) return;

    const callback = () => handleScrollEnd(currentElement);

    currentElement.addEventListener('scrollend', callback);

    return () => {
      if (!currentElement) return;

      currentElement.removeEventListener('scrollend', callback);
    };
  }, [handleScrollEnd]);

  const handleClick = useCallback(
    (index: number) => {
      const { current: currentElement } = ref;

      if (!currentElement) return;

      const { scrollWidth } = currentElement;

      const elementWidth = scrollWidth / numberOfElements;

      currentElement.scrollTo({
        left: index * elementWidth,
        behavior: 'smooth',
      });

      setCurrent(index);
    },
    [numberOfElements]
  );

  return (
    <div className='IntakeTestimonialsSectionMobile'>
      <div
        className='IntakeTestimonialsSectionMobile__items-container'
        ref={ref}
      >
        {TESTIMONIALS.map((testimonial, index) => (
          <div
            className='IntakeTestimonialsSectionMobile__item-wrapper'
            key={index}
          >
            <div className='IntakeTestimonialsSectionMobile__item'>
              <div className='m-[30px] my-[50px] flex flex-col gap-[20px] md:m-[48px]'>
                <Typography variant='quote' as='p'>
                  {testimonial.quote}
                </Typography>

                <Typography variant='body' color='semidark'>
                  {testimonial.name}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className='IntakeTestimonialsSectionMobile__navigation-wrapper'>
        <span className='IntakeTestimonialsSectionMobile__navigation'>
          <div className='IntakeTestimonialsSectionMobile__navigation-items'>
            {TESTIMONIALS.map((_, index) => (
              <div
                className={clsx(
                  'IntakeTestimonialsSectionMobile__navigation-item',
                  {
                    'IntakeTestimonialsSectionMobile__navigation-item--selected':
                      index === current,
                  }
                )}
                key={index}
                onClick={() => handleClick(index)}
              >
                <svg
                  width='10'
                  height='10'
                  viewBox='0 0 10 10'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <rect width='10' height='10' rx='5' fill='#5C5954' />
                </svg>
              </div>
            ))}
          </div>
        </span>
      </div>
    </div>
  );
};
